// @ts-nocheck

import * as Types from '../../../../../../graphql/types';

import { ValidationsFragment } from './ValidateImporterColumn.graphql';
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
import { ValidationsFragmentDoc } from './ValidateImporterColumn.graphql';
export type ValidateImporterTimesheetRowQueryVariables = Types.Exact<{
  input: Types.TimesheetImportValidationQueryModelInput;
}>;

export type ValidateImporterTimesheetRowQuery = { result: { validations?: Array<ValidationsFragment | null> | null } };

export const ValidateImporterTimesheetRowDocument = gql`
    query ValidateImporterTimesheetRow($input: TimesheetImportValidationQueryModelInput!) {
  result: validateTimesheetImportRow(input: $input) {
    validations {
      ...Validations
    }
  }
}
    ${ValidationsFragmentDoc}` as unknown as DocumentNode<
  ValidateImporterTimesheetRowQuery,
  ValidateImporterTimesheetRowQueryVariables
>;
